import React, { Component } from 'react';
import { Menu, Icon } from 'antd';
import ScrollableAnchor, {goToAnchor} from 'react-scrollable-anchor';
class TopMenu extends Component {
  state = {
    hamburger: false,
  }
  toggleHamburgerMenu() {
    this.setState({hamburger: !this.state.hamburger})
  }
  render() {
    console.log(window.innerWidth)
    return (
      <div>
        {window.innerWidth<768 && <Icon className="hamburger-menu-icon" type="menu-fold" onClick={this.toggleHamburgerMenu.bind(this)}/>}
        {((window.innerWidth>=768) || (this.state.hamburger==true)) &&
          <Menu
            onClick={this.props.handleClick}
            selectedKeys={[this.props.current]}
            mode={window.innerWidth>=768?"horizontal":"inline"}
            className={window.innerWidth>=768?"top-menu": "top-menu mobile-menu"}
          >
            {(window.innerWidth<768) && <Icon type="close" onClick={this.toggleHamburgerMenu.bind(this)}/> }
            <Menu.Item key="products">
              <a onClick={() => goToAnchor('solutions')} >SOLUTIONS</a>
            </Menu.Item>
    
            <Menu.Item key="aboutus">
              <a onClick={() => goToAnchor('aboutus')}>ABOUT US</a>
            </Menu.Item>
            <Menu.Item key="contact">
              <a onClick={() => goToAnchor('contact-form')}>CONTACT</a>
            </Menu.Item>
          </Menu>
        }
      </div>
    );
  }
}

export default TopMenu;


// WEBPACK FOOTER //
// ./src/menu.js